import { GET_REPORT } from './getReport';

export const bpfReportAPI = {
  getReport: GET_REPORT,
};
